import { render } from "./LoadingComponent.vue?vue&type=template&id=346f0c5f"
import script from "./js/loadingComponent.js?vue&type=script&lang=js&external"
export * from "./js/loadingComponent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__